import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Tooltip as ReactTooltip } from "react-tooltip";
import firebase from "firebase/compat/app";

const Chapter6_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist ein Vorteil von geografischer Redundanz in der Cloud?",
      options: [
        {
          value: "A",
          label:
            "Daten bleiben auch bei regionalen Ausfällen oder Katastrophen verfügbar.",
        },
        {
          value: "B",
          label:
            "Geografische Redundanz reduziert die Speicherkosten für Cloud-Dienste erheblich.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welche Funktion haben Snapshots im Cloud-Notfallmanagement?",
      options: [
        {
          value: "A",
          label:
            "Sie sichern den Zustand eines Systems zu einem bestimmten Zeitpunkt und ermöglichen eine schnelle Wiederherstellung.",
        },
        {
          value: "B",
          label:
            "Snapshots verschlüsseln Daten automatisch, um sie vor unbefugtem Zugriff zu schützen.",
        },
      ],
      correct: "A",
    },
  ];


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 6_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "6_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("6_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 6_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "6_4",
              completedChapters: ["6_4"],
            });
          console.log("Dokument erstellt mit Kapitel 6_4");
        }

        navigate("/6_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  6. Sicheres Cloud Computing
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Notfallmanagement in der Cloud
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 6: Sicheres Cloud Computing
          </h3>
          <h2 className="text-center p-3">Notfallmanagement in der Cloud</h2>
          <img
            src="/images/backup.webp"
            alt="Backup-Force"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 pt-5 mx-auto">
            Um die Sicherheit und Verfügbarkeit von Daten und Anwendungen und
            die Geschäftskontinuität in der Cloud zu gewährleisten, ist ein
            effektives Notfallmanagement unerlässlich. Du hast ja bereits im
            Notfallmanagement für Netzwerke das{" "}
            <Link to="/4_5#ir" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Incident Response (IR)
            </Link>{" "}
            als schnelle Reaktion auf Vorfälle und das{" "}
            <Link to="/4_5#dr" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Disaster Recovery (DR)
            </Link>{" "}
            für die Wiederherstellung betroffener Daten nach großen Schäden
            kennengelernt. Während die grundlegenden Konzepte des
            Notfallmanagements wie Reaktionspläne, regelmäßige Tests und klare
            Verantwortlichkeiten auch für die Cloud gelten, erfordert die Cloud
            spezifische Anpassungen und neue Ansätze, die auf die speziellen
            Eigenschaften der Cloud-Infrastruktur zurückzuführen sind.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Prognosen zufolge wird der Umsatz mit Cloud-Sicherheitslösungen in
            Deutschland bis 2027 auf rund 459 Millionen Euro ansteigen, was
            einer durchschnittlichen jährlichen Wachstumsrate von etwa 47%
            zwischen 2022 und 2027 entspricht. (Statista 2024)
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Incident Response (IR) in der Cloud</h3>
            <p className="col-lg-11 mx-auto">
              Auch in der Cloud konzentriert sich Incident Response darauf,
              Sicherheitsvorfälle wie unbefugten Zugriff, Datenlecks oder
              Angriffe auf Cloud-Dienste schnell zu erkennen, einzudämmen, zu
              analysieren und zu beheben. Als Besonderheiten müssen die nachfolgenden Punkte
              beachtet werden:
            </p>
          </div>
          <div className="col-lg-11 p-3 text-start mx-auto">
            <h5 className="pb-3 fw-bold">Cloud-spezifische Bedrohungen:</h5>
            <p>
              <ul>
                <li>
                  Unsachgemäße Konfigurationen, wie öffentlich zugängliche{" "}
                  <span
                    data-tooltip-id="tooltip-s3"
                    data-tooltip-content="S3-Buckets sind Speicherorte in Amazons Cloud-Service Amazon S3 (Simple Storage Service), in denen Daten wie Dateien, Bilder oder Videos sicher abgelegt und verwaltet werden können. Sie funktionieren wie virtuelle Ordner, in denen Unternehmen Daten speichern, abrufen und weltweit verfügbar machen können."
                    className="custom-tooltip-trigger"
                  >
                    {" "}
                    S3-Buckets,{" "}
                  </span>{" "}
                  können sensible Daten gefährden.
                </li>
                <li>
                  {" "}
                  <span
                    data-tooltip-id="tooltip-apimis"
                    data-tooltip-content="API-Missbrauch tritt auf, wenn Angreifer Schwachstellen in Programmierschnittstellen (APIs) ausnutzen, um unbefugten Zugriff auf Systeme, Daten oder Funktionen zu erlangen."
                    className="custom-tooltip-trigger"
                  >
                    {" "}
                    API-Missbrauch{" "}
                  </span>{" "}
                  oder kompromittierte Anmeldedaten sind häufige Angriffspunkte
                  in Cloud-Umgebungen.
                </li>
              </ul>
            </p>
            <h5 className="pb-3 pt-5 fw-bold">Erweiterte Überwachung:</h5>
            <p>
              <ul>
                <li>
                  Cloud-Anbieter stellen leistungsstarke Tools wie{" "}
                  <strong>
                    {" "}
                    AWS CloudTrail, Azure Monitor oder Google Cloud Logging{" "}
                  </strong>{" "}
                  bereit, die speziell entwickelt wurden, um Aktivitäten und
                  Änderungen in der Cloud-Infrastruktur detailliert zu
                  überwachen. Diese Dienste protokollieren beispielsweise, wer
                  auf Ressourcen zugegriffen hat, welche Änderungen vorgenommen
                  wurden und wann diese Ereignisse stattgefunden haben.
                </li>
              </ul>
            </p>

            <h5 className="pb-3 pt-5 fw-bold">Automatisierung:</h5>
            <p>
              <ul>
                <li>
                  Automatisierte Alarme und Reaktionen, die von Cloud-native
                  Sicherheitsdiensten wie AWS GuardDuty, Azure Security Center
                  oder Google Cloud Security Command Center bereitgestellt
                  werden, <strong> überwachen kontinuierlich </strong> die
                  Cloud-Umgebung auf potenzielle Bedrohungen wie verdächtigen
                  Datenverkehr, unautorisierte Zugriffsversuche oder
                  ungewöhnliche Aktivitäten. Sobald eine Anomalie erkannt wird,
                  löst der Dienst automatisch einen Alarm aus, der das
                  IT-Sicherheitsteam informiert.
                  <br />
                  <br />
                  In vielen Fällen können diese Dienste auch{" "}
                  <strong> automatische Gegenmaßnahmen </strong> einleiten,
                  beispielsweise das Sperren einer verdächtigen IP-Adresse, das
                  Deaktivieren kompromittierter Benutzerkonten oder das
                  Isolieren betroffener Ressourcen. Dadurch wird die Zeitspanne
                  zwischen der Erkennung eines Vorfalls und der Reaktion darauf
                  erheblich verkürzt. Sie ermöglichen eine schnelle Reaktion,
                  auch außerhalb der regulären Arbeitszeiten.
                </li>
              </ul>
            </p>
            <h5 className="pb-3 pt-5 fw-bold">Gemeinsame Verantwortung:</h5>
            <p>
              <ul>
                <li>
                  Im{" "}
                  <Link to="/6_2" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    Shared Responsibility Model{" "}
                  </Link>
                  liegt die Verantwortung für die Sicherheit der in der Cloud
                  betriebenen Anwendungen, Daten und Konfigurationen beim
                  Nutzer, während der Anbieter die Sicherheit der Infrastruktur
                  gewährleistet.{" "}
                </li>
              </ul>
            </p>
          </div>
          <div className="p-5 text-center">
            <p className="col-lg-9 mx-auto  p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              <strong>Beispiel für IR in der Cloud: </strong>
              <br />
              <br />
              Ein Angreifer nutzt gestohlene Zugangsdaten, um auf eine Datenbank
              in der Cloud zuzugreifen. Die Incident Response Maßnahmen
              umfassen:
              <br />
              <br />
              <strong>Eindämmung: </strong>Sofortiges Sperren der betroffenen
              Konten und Trennen der Datenbank von der Außenwelt.
              <br />
              <strong>Analyse: </strong>Untersuchung der Logs, um festzustellen,
              welche Daten betroffen sind.
              <br />
              <strong>Behebung: </strong>Änderung der Zugriffsrechte und
              Implementierung von Multi-Faktor-Authentifizierung.
              <br />
              <strong>Prävention: </strong>Optimierung der Konfiguration und
              Einführung zusätzlicher Sicherheitsmaßnahmen.
              <br />
            </p>
          </div>
          <ReactTooltip
            id="tooltip-s3"
            place="top"
            className="custom-tooltip"
          />
          <ReactTooltip
            id="tooltip-apimis"
            place="top"
            className="custom-tooltip"
          />
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Besonderheiten der Disaster Recovery in der Cloud:
            </h3>
            <p className="col-lg-11 mx-auto">
              Disaster Recovery im Cloud-Computing muss auch hier wie im
              Netzwerk Dienste und Daten nach größeren Ausfällen oder
              Katastrophen wiederherstellen. Die Cloud bietet hierfür erhebliche
              Vorteile durch ihre Skalierbarkeit, Flexibilität und integrierte
              Redundanz.
            </p>

            <div className="col-lg-11 p-3 text-start mx-auto">
              <h5 className="pb-3 fw-bold">Geografische Redundanz:</h5>
              <p>
                <ul>
                  <li>
                    Cloud-Anbieter wie AWS, Microsoft Azure oder Google Cloud
                    betreiben Rechenzentren in verschiedenen Regionen.
                    Unternehmen können ihre Daten und Dienste so konfigurieren,
                    dass sie bei einem regionalen Ausfall nahtlos auf andere
                    Regionen umgeleitet werden.
                  </li>
                </ul>
              </p>
              <h5 className="pb-3 pt-5 fw-bold">Snapshots und Replikation:</h5>
              <p>
                <ul>
                  <li>
                    Cloud-Dienste ermöglichen regelmäßige Snapshots von
                    virtuellen Maschinen und Datenbanken, die für eine schnelle
                    Wiederherstellung genutzt werden können. Snapshots sind
                    Momentaufnahmen eines Systems oder einer Datenbank zu einem
                    bestimmten Zeitpunkt. Sie speichern den Datenstand und die
                    Konfiguration, sodass im Fall eines Fehlers oder einer
                    Datenkorruption schnell zu diesem Zustand zurückgekehrt
                    werden kann. Snapshots sind effizient, da sie nur die
                    Änderungen seit der letzten Momentaufnahme speichern. Sie eignen sich besonders für kurzfristige Sicherungen und
                    Wiederherstellungen.
                  </li>
                  <li>
                    Daten können automatisch über mehrere Zonen oder Regionen
                    hinweg repliziert werden. Bei der Replikation werden in
                    Echtzeit oder in geplanten Intervallen Datenkopien von einem
                    Speicherort erstellt. Diese Kopien werden an einem
                    geografisch getrennten Standort gespeichert, um bei
                    Ausfällen verfügbar zu bleiben. Replikation bietet
                    langfristige Redundanz und Ausfallsicherheit, indem sie
                    sicherstellt, dass Daten auch bei Hardware-Ausfällen oder
                    regionalen Katastrophen zugänglich sind.
                  </li>
                </ul>
              </p>

              <h5 className="pb-3 pt-5 fw-bold">
                Disaster Recovery as a Service (DRaaS):
              </h5>
              <p>
                <ul>
                  <li>
                    Viele Cloud-Anbieter bieten DRaaS-Lösungen an, die speziell
                    darauf ausgelegt sind, die Wiederherstellung von Diensten
                    und Daten nach einem Ausfall zu beschleunigen.
                  </li>
                </ul>
              </p>
              <h5 className="pb-3 pt-5 fw-bold">Flexibilität und Kosten:</h5>
              <p>
                <ul>
                  <li>
                    Durch die Nutzung von Pay-as-you-go-Modellen können
                    Unternehmen kosteneffizient Backups und Redundanz-Lösungen in
                    der Cloud betreiben, ohne in eigene Hardware investieren zu
                    müssen.
                  </li>
                </ul>
              </p>
            </div>
            <div className="p-5 text-center">
              <p className="col-lg-9 mx-auto  p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                <strong>Beispiel für DR in der Cloud: </strong>
                <br />
                <br />
                Ein Rechenzentrum eines Cloud-Anbieters fällt aufgrund einer
                Naturkatastrophe aus. Dank einer Multi-Region-Strategie wird der
                Betrieb automatisch auf ein Backup-System in einer anderen
                Region umgeleitet. Snapshots und Replikationen sorgen dafür,
                dass Datenverluste minimal bleiben. Die Dienste stehen
                nahezu unterbrechungsfrei zur Verfügung.
              </p>
            </div>

            <h4 className="p-5">Cloud-Modelle für Disaster Recovery:</h4>
            <p className="col-lg-11  mx-auto">
              Cloud-Anbieter bieten verschiedene DR-Modelle an. Sie
              unterscheiden sich in ihrer Komplexität, den Kosten und der
              Wiederherstellungszeit. Sie können an die individuellen
              Anforderungen eines Unternehmens angepasst werden..
              <br />
              <br />
            </p>
            <p className="col-lg-11 text-start mx-auto">
              <strong>Backup and Restore: </strong> Das einfachste Modell. Daten
              und Anwendungen werden regelmäßig gesichert und im Falle eines
              Vorfalls aus den Backups wiederhergestellt. <br />
              <ul>
                <li>
                  Vorteile: Einfach in der Implementierung und kosteneffizient.
                </li>
                <li>
                  Nachteile: Wiederherstellung kann zeitaufwendig sein,
                  insbesondere bei großen Datenmengen.
                </li>
              </ul>
              <br />
              <br />
              <strong> Pilot Light: </strong>Eine minimale Infrastruktur wird in
              der Cloud vorgehalten und kann im Notfall hochgefahren werden.
              <br />
              <ul>
                <li>
                  Vorteile: Geringe Betriebskosten, da nur die Grundfunktionen
                  vorgehalten werden.
                </li>
                <li>
                  Nachteile: Höherer Zeitaufwand für die vollständige
                  Wiederherstellung.
                </li>
              </ul>
              <br />
              <br />
              <strong>Warm Standby: </strong>Eine reduzierte, aber funktionale
              Kopie der Infrastruktur wird in der Cloud betrieben und kann im
              Ernstfall schnell auf volle Kapazität hochgefahren werden.
              <br />
              <ul>
                <li>
                  Vorteile: Schnellere Wiederherstellung als beim
                  Pilot-Light-Ansatz.
                </li>
                <li>Nachteile: Höhere laufende Kosten.</li>
              </ul>
              <br />
              <br />
              <strong>Multi-Site: </strong>Volle Replikation der Infrastruktur
              über mehrere geografische Standorte hinweg.
              <br />
              <ul>
                <li>
                  Vorteile: Minimale Ausfallzeiten durch sofortige Verfügbarkeit.
                </li>
                <li>Nachteile: Sehr hohe Kosten und Komplexität.</li>
              </ul>
              <br />
              <br />
            </p>
          </div>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Monitoring und Logging</h3>
            <p className="col-lg-11 mx-auto">
              Monitoring und Logging ergänzende
              Sicherheitsmaßnahmen in der Cloud, mit denen alle Aktivitäten und
              Ereignisse überwacht und aufgezeichnet werden. Diese Praktiken
              gewährleisten, dass die Cloud-Umgebung transparent wird,
              Sicherheitsvorfälle frühzeitig erkannt und alle Aktivitäten zur
              späteren Analyse umfassend dokumentiert werden.
              <br />
              <br />
              <strong>Monitoring </strong>
              sammelt und analysiert Daten zu Netzwerkverkehr, Benutzerzugriffen
              und Ressourcenverbrauch, um Sicherheitsvorfälle, Leistungsprobleme
              und Compliance-Verstöße frühzeitig zu erkennen. Bekannte
              Monitoring-Tools sind beispielsweise Amazon CloudWatch (für AWS),
              Microsoft Azure Monitor (für Azure) und Google Cloud Monitoring
              (für GCP).
              <br />
              <br />
              <strong>Logging </strong>
              protokolliert alle Ereignisse wie Anmeldungen, Zugriffe und
              Änderungen an Daten. Diese{" "}
              <strong>Logs (Ereignisprotokolle) </strong>sind wichtig, um
              Sicherheitsvorfälle im Nachgang zu analysieren und die Compliance
              zu belegen. Sie werden meist in Textdateien gespeichert, die im
              Format .log oder .txt vorliegen.
              <br />
              <br />
              Hier ist ein Beispiel für ein Ereignisprotokoll (Log), das zeigt,
              wie ein typisches Log-Format aussehen könnte:
            </p>
          </div>

          <div class="container p-5 text-start">
            <div class="row align-items-start">
              <div class="col mx-auto p-3 code-container">
                One of three columns
                <pre>
                  <code>
                    "timestamp": "2024-10-25T10:15:30Z", <br />
                    "log_level": "INFO", <br />
                    "service": "user-authentication", <br />
                    "message": "User login successful", <br />
                    "user_id": "12345", <br />
                    "ip_address": "192.168.1.10", <br />
                    "location": "Berlin, Germany", <br />
                    "session_id": "abc123xyz456", <br />
                    "details": <br />
                    "method": "password", <br />
                    "multi_factor_auth": true, <br />
                    "device": "Chrome browser on Windows 10" <br />
                  </code>
                </pre>
              </div>
              <div class="col">
                <p className="text-start p-3 mx-auto">
                  Erklärung der Log-Einträge:
                  <br />
                  <ul>
                    <li>timestamp: Zeitpunkt des Ereignisses im UTC-Format.</li>
                    <li>
                      log_level: Schweregrad der Nachricht, z. B. INFO, WARNING,
                      ERROR.
                    </li>
                    <li>
                      service: Dienst, der das Log erstellt hat, hier z. B. die
                      Benutzeranmeldung.
                    </li>
                    <li>message: Kurze Beschreibung des Ereignisses.</li>
                    <li>user_id: Eindeutige ID des Benutzers.</li>
                    <li>ip_address: IP-Adresse des Nutzers.</li>
                    <li>location: Standort des Zugriffs.</li>
                    <li>session_id: Sitzung des Benutzers.</li>
                    <li>
                      details: Weitere Informationen, z. B. Anmeldemethode und
                      Gerät.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="pt-5 text-center">
            <h3 className="p-5">Besonderheiten von Cloud-Backups</h3>

            <p className="col-lg-11 mx-auto">
              Effektive{" "}
              <Link to="/3_2#backup" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Backup-Strategien
              </Link>
              wurden bereits vorgestellt. Cloud-Backups bieten gegenüber
              traditionellen Backup-Methoden einige Vorteile. Durch die Automatisierung ermöglichen Cloud-Anbieter
              regelmäßige und planmäßige Sicherungen ohne zusätzlichen manuellen
              Aufwand. Eine der größten Stärken von Cloud-Backups ist die{" "}
              <strong>geografische Redundanz: </strong> Daten werden in
              verschiedenen Regionen oder Verfügbarkeitszonen gespeichert, um
              auch bei regionalen Ausfällen verfügbar zu bleiben.
              <br />
              <br />
              Darüber hinaus profitieren Unternehmen von der{" "}
              <strong> Skalierbarkeit </strong> der Cloud. Speicherplatz kann
              flexibel erweitert werden, und durch{" "}
              <strong> Tiered-Storage-Optionen </strong> lassen sich Daten
              kosteneffizient sichern. Tiered-Storage-Optionen bezeichnen ein
              Speicher-Konzept, bei dem Daten je nach ihrer Nutzungshäufigkeit
              und ihrem Wert auf unterschiedliche Speicherklassen oder -ebenen
              verteilt werden. Ziel ist es, Speicherkosten zu optimieren, indem
              häufig genutzte Daten auf schnellerem, aber teurerem SSDs-Speicher
              liegen (Hot Storage), während selten genutzte Daten auf
              kostengünstigeren, langsameren Speicher verschoben werden (Cold
              Storage). Es gibt auch noch sehr kostengünstige Archiv-Speicher
              für Daten, die fast nie abgerufen werden, wie für Daten, die nur
              aus rechtlichen Gründen aufbewahrt werden.
              <br />
              <br />
              Auch die schnelle Wiederherstellung von Daten ist eine
              Besonderheit: Mit <strong>Snapshots </strong> kann der Zustand
              eines Systems zu einem bestimmten Zeitpunkt gesichert und
              innerhalb kürzester Zeit wiederhergestellt werden. Zudem
              unterstützen Cloud-Backups häufig
              <strong> automatische Verschlüsselung, </strong>sowohl während der
              Übertragung als auch im Speicher, was zusätzliche Sicherheit
              bietet.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">
              Business Continuity and Disaster Recovery (BCDR)
            </h3>

            <p className="col-lg-11  mx-auto">
              BCDR (Business Continuity and Disaster Recovery) ist ein
              umfassender Ansatz, der die Reaktion auf Vorfälle{" "}
              <strong> (Incident Response, IR) </strong> und die
              Wiederherstellung nach Katastrophen{" "}
              <strong> (Disaster Recovery, DR) </strong> miteinander verbindet.
              Ziel ist es, sicherzustellen, dass ein Unternehmen auch während
              eines Vorfalls weiterhin betriebsfähig bleibt und nach einer
              Störung oder einem Ausfall schnell wieder in den Normalbetrieb
              zurückkehren kann. BCDR geht dabei über die rein technischen
              Maßnahmen hinaus und betrachtet auch Prozesse, Ressourcen und die
              gesamte Geschäftskontinuität.
              <br />
              <br />
             In der Cloud bietet BCDR besondere Vorteile, weil viele Anbieter wie Amazon Web Services, Microsoft Azure oder Google Cloud Funktionen integriert haben, die speziell darauf ausgelegt sind, den Geschäftsbetrieb auch bei Störungen aufrechtzuerhalten und Systeme schnell wiederherzustellen. Ein zentraler Vorteil ist die <strong>geografische Redundanz. </strong>Dabei werden Daten und Anwendungen nicht nur in einem einzigen Rechenzentrum gespeichert, sondern parallel in mehreren Regionen. Fällt ein Standort durch einen technischen Defekt, einen Stromausfall oder eine Naturkatastrophe aus, kann automatisch ein anderer Standort übernehmen. Für Nutzer bleibt der Dienst im Idealfall weiterhin erreichbar oder nur kurzzeitig unterbrochen.
<br />
              <br />
Ein weiterer wichtiger Baustein sind sogenannte <strong> Snapshots. </strong> Das sind Sicherungspunkte, also gespeicherte Zustände eines Systems zu einem bestimmten Zeitpunkt. Kommt es beispielsweise zu einem Cyberangriff oder zu einem Fehler bei einer Software-Änderung, kann das Unternehmen auf einen früheren, funktionierenden Stand zurückgreifen. Anstatt das gesamte System neu aufzusetzen, wird einfach der zuletzt gesicherte Zustand wiederhergestellt. Das spart Zeit und reduziert Ausfallzeiten erheblich.
<br />
              <br />
Hinzu kommt die <strong>automatische Skalierung. </strong> In einer Krisensituation oder während der Wiederherstellung kann der Bedarf an Rechenleistung kurzfristig stark ansteigen. Cloud-Plattformen können in solchen Momenten automatisch zusätzliche Serverkapazitäten bereitstellen und diese wieder reduzieren, sobald sie nicht mehr benötigt werden. Die Infrastruktur passt sich also flexibel an die aktuelle Belastung an, ohne dass manuell eingegriffen werden muss.
<br />
              <br />
Insgesamt bedeutet das: Viele Funktionen, die früher nur mit großem technischen und finanziellen Aufwand möglich waren, sind in der Cloud bereits integriert. Unternehmen können dadurch schneller auf Vorfälle reagieren, Ausfallzeiten verkürzen und ihre Geschäftsprozesse auch in Krisensituationen stabil halten.
              <br />
              <br />
              Diese integrierten Cloud-Funktionen reduzieren die Komplexität und
              die Kosten für die Implementierung eines BCDR-Plans erheblich, da
              Unternehmen keine eigene Infrastruktur für Backups oder Redundanz
              aufbauen müssen. BCDR in der Cloud verbindet die technische Stärke
              der Cloud mit bewährten Strategien für die Geschäftskontinuität
              und ermöglicht eine schnelle und effiziente Bewältigung von
              Störungen, wodurch Risiken minimiert und Ausfallzeiten reduziert
              werden.
            </p>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter6_4;
